import { useMutation, useQueryClient } from '@tanstack/react-query';
import { reviewsService } from '../../../../../../../../../../shared/src/api';
import { queryKey } from '../../../../../constant/queryKey';
import { useGoodsSno } from '../../../../../hooks/useGoodsSno';
import type { GetGoodsReviewsResponse } from '../../../../../../../../../../shared/src/api/goodsService/getGoodsReviews';

export const usePostReviewLike = (reviewSno: number) => {
  const goodsSno = useGoodsSno();
  const client = useQueryClient();

  return useMutation({
    mutationFn: () => reviewsService.postReviewLike(reviewSno),
    onSuccess: data => {
      client.setQueryData<GetGoodsReviewsResponse>(
        queryKey.goodsReviews(goodsSno),
        oldData => {
          if (!oldData) return oldData;
          return {
            ...oldData,
            reviews: oldData.reviews.map(review =>
              review.sno === reviewSno
                ? {
                    ...review,
                    review_like: data.review_like,
                    review_likes_count: review.review_likes_count + 1,
                  }
                : review,
            ),
          };
        },
      );
    },
  });
};
